exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "p._1fiRsj0XNM8cXL4fFoynwj,p._1x_0igQknqHIdQvbRPCa19{margin:10px 0}._1x_0igQknqHIdQvbRPCa19{color:#d73f3f}", ""]);

// exports
exports.locals = {
	"error": "_1x_0igQknqHIdQvbRPCa19",
	"status": "_1fiRsj0XNM8cXL4fFoynwj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true}!./app/styles/utilsStyles.css
// module id = 1238
// module chunks = 1